import { useState } from "react";
import { apiClient } from "../../utils/api";
import { SmsVerificationRequest, SmsVerificationResponse } from "../../types/auth";

interface DuplicateResponse {
  duplicate: boolean;
  platform: "aivy" | "kakao" | "google" | "naver";
  status: boolean;
}

const useSmsVerification = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [verificationError, setVerificationError] = useState<string>("");
  const [authcode, setAuthcode] = useState<string>("");
  const [isDuplicate, setIsDuplicate] = useState<boolean>(false);
  const [duplicatePlatform, setDuplicatePlatform] = useState<string>("");

  const verifySms = async (data: SmsVerificationRequest) => {
    try {
      setIsLoading(true);
      setVerificationError("");
      setIsDuplicate(false);
      setDuplicatePlatform("");

      const response = await apiClient.post<SmsVerificationResponse | DuplicateResponse>(
        "/api/v1/auth/sms/verification",
        data
      );

      if ("duplicate" in response.data) {
        setIsDuplicate(true);
        setDuplicatePlatform(response.data.platform);
        setVerificationError(`${response.data.platform}로 이미 가입된 번호입니다.`);
        return { isDuplicate: true, platform: response.data.platform };
      }

      setAuthcode(response.data.authcode);
      return { isDuplicate: false, authcode: response.data.authcode };
    } catch (error) {
      if (error instanceof Error) {
        setVerificationError(error.message);
      } else {
        setVerificationError("문자 인증 요청 중 오류가 발생했습니다.");
      }
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    verifySms,
    isLoading,
    verificationError,
    setVerificationError,
    authcode,
    isDuplicate,
    duplicatePlatform,
  };
};

export default useSmsVerification; 